/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module) {
	'use strict';

	Module.Tabs.StaticallyLinkedTabs = function(parent) {
		this.on = function() {
			parent.on.apply(this, arguments);
		};
		this.after = function() {
			parent.after.apply(this, arguments);
		};

		this.selectingTab = function(tab) {
			// Trigger the animation
			parent.selectingTab.apply(this, arguments);
			var href = tab.attr('data-href');
			tab.prop('href', href);
			// Trigger loading the URL with the selector.
			window.location.href = href;
		};

		// Overridden
		this.beforeLoad = function (event, ui) {
			// Cleanly stop the Ajax request (for >= 1.9 versions of jQuery UI)
			ui.jqXHR.abort();
			event.preventDefault();
			return false;
		};

	};
}(window.Tc.Module));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Tabs.StaticallyLinkedTabs.js
// module id = 193
// module chunks = 0